var r={backspace:"Backspace",arrowLeft:"ArrowLeft",arrowRight:"ArrowRight"};export{r as KEYBOARD_EVENTS};
//# sourceMappingURL=otpInput.constants.js.map
